var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinwheelcreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.5 78.8327C63.5203 78.8327 79.75 62.7896 79.75 42.9994C79.75 23.2091 63.5203 7.16602 43.5 7.16602C23.4797 7.16602 7.25 23.2091 7.25 42.9994C7.25 62.7896 23.4797 78.8327 43.5 78.8327Z",
    stroke: "#399E79",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 43H43.5M43.5 43H32.625M43.5 43V32.25M43.5 43V53.75",
    stroke: "#399E79",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinwheelcreate);
export default __webpack_public_path__ + "static/media/spinwheel create.781e395035c18aee1fa1b49d03485c67.svg";
export { ForwardRef as ReactComponent };